export { FacetTerms } from './FacetTerms';
